export default __webpack_public_path__ + "static/media/Patricia Santos Souza.7dcfce7f.png";